import { inject } from '@angular/core';
import { CognitoService } from '../services/cognito.service';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const service = inject(CognitoService);
  const authService = inject(AuthService);
  const router = inject(Router);
  return service.fetchAuthSession().pipe(
    map((auth) => {
      if (!auth?.tokens) {
        router.navigate(['/login']);
      }
      authService.token = auth?.tokens?.accessToken;
      return auth?.tokens;
    }),
  );
};
